export * from './index';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-translate/ng2-translate.js
// module id = 75
// module chunks = 10